import Student from '@/api/home/student'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  profile: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PROFILES(state, data) {
    state.profile = data
  }
}

export const actions = {
  fetchProfile(context = {}) {
    return Student.getProfile().then(response => {
      context.commit('RECEIVE_PROFILES', response.data)
      return Promise.resolve(response)
    })
  },

  uploadPhoto(context, data) {
    return Student.uploadPhoto(data)
  },
  changePwd(context, data) {
    return Student.changePassword(data)
  }
}
